import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { StudentProvider } from "@/context/StudentContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { MobileFrame } from "@/components/MobileFrame";
import { BottomNav } from "@/components/BottomNav";

import Welcome from "@/pages/Welcome";
import Login from "@/pages/Login";
import SdquLogin from "@/pages/SdquLogin";
import Informasi from "@/pages/Informasi";
import ManageInfoPage from "@/pages/admin/ManageInfoPage";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Home from "@/pages/Home";
import Belajar from "@/pages/Belajar";
import Kelola from "@/pages/Kelola";
import Info from "@/pages/Info";
import Pesan from "@/pages/Pesan";
import ChatThread from "@/pages/ChatThread";
import Profil from "@/pages/Profil";
import Jadwal from "@/pages/Jadwal";
import Absensi from "@/pages/Absensi";
import Hafalan from "@/pages/Hafalan";
import Doa from "@/pages/Doa";
import Perkembangan from "@/pages/Perkembangan";
import Galeri from "@/pages/Galeri";
import SPP from "@/pages/SPP";
import Radio from "@/pages/Radio";
import StudentProfile from "@/pages/StudentProfile";
import InputAbsensi from "@/pages/teacher/InputAbsensi";
import InputHafalan from "@/pages/teacher/InputHafalan";
import InputProgress from "@/pages/teacher/InputProgress";
import InputPenilaian from "@/pages/teacher/InputPenilaian";
import ManageSiswa from "@/pages/teacher/ManageSiswa";
import TeacherStudents from "@/pages/teacher/TeacherStudents";
import ManageSPP from "@/pages/admin/ManageSPP";
import SppReport from "@/pages/admin/SppReport";
import ManageJadwal from "@/pages/admin/ManageJadwal";
import KehadiranDetail from "@/pages/admin/KehadiranDetail";
import ManageExport from "@/pages/admin/ManageExport";
import ImportData from "@/pages/admin/ImportData";
import NomorSiswaImport from "@/pages/admin/NomorSiswaImport";
import ManageKajianRadio from "@/pages/admin/ManageKajianRadio";
import ManageUsers from "@/pages/admin/ManageUsers";
import Laporan from "@/pages/Laporan";
import InputLaporan from "@/pages/teacher/InputLaporan";
import KegiatanGuru from "@/pages/teacher/KegiatanGuru";
import Riwayat from "@/pages/teacher/Riwayat";
import AdminGuruAttendance from "@/pages/admin/AdminGuruAttendance";
import AdminMukafaah from "@/pages/admin/AdminMukafaah";
import AdminKirimPesan from "@/pages/admin/AdminKirimPesan";
import AdminGuruDetail from "@/pages/admin/AdminGuruDetail";
import GuruDetail from "@/pages/admin/GuruDetail";
import ParentDetail from "@/pages/admin/ParentDetail";
import AdminAttendance from "@/pages/admin/AdminAttendance";
import Materi from "@/pages/Materi";
import KontenHafalan from "@/pages/admin/KontenHafalan";
import MonitorUsers from "@/pages/admin/MonitorUsers";

// wrap a page with the mobile frame + bottom nav
const Framed = ({ children, nav = true }) => (
  <MobileFrame nav={nav ? <BottomNav /> : null}>{children}</MobileFrame>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <StudentProvider>
          <Routes>
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/login" element={<Login />} />
            <Route path="/sdqu-login" element={<SdquLogin />} />
            <Route path="/informasi" element={<Informasi />} />
            <Route path="/kelola/informasi" element={<ProtectedRoute roles={["admin"]}><Framed><ManageInfoPage /></Framed></ProtectedRoute>} />
            <Route path="/register" element={<Register />} />
            <Route path="/sdqu-register" element={<Register school="sdqu" />} />
            <Route path="/lupa-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/" element={<ProtectedRoute><Framed><Home /></Framed></ProtectedRoute>} />
            <Route path="/tk/admin/dashboard" element={<ProtectedRoute roles={["admin"]}><Framed><Home /></Framed></ProtectedRoute>} />
            <Route path="/sdqu/admin/dashboard" element={<ProtectedRoute roles={["admin"]}><Framed><Home /></Framed></ProtectedRoute>} />
            <Route path="/belajar" element={<ProtectedRoute roles={["orangtua"]}><Framed><Belajar /></Framed></ProtectedRoute>} />
            <Route path="/kelola" element={<ProtectedRoute roles={["guru", "admin"]}><Framed><Kelola /></Framed></ProtectedRoute>} />
            <Route path="/info" element={<ProtectedRoute><Framed><Info /></Framed></ProtectedRoute>} />
            <Route path="/pesan" element={<ProtectedRoute><Framed><Pesan /></Framed></ProtectedRoute>} />
            <Route path="/pesan/:userId" element={<ProtectedRoute><Framed nav={false}><ChatThread /></Framed></ProtectedRoute>} />
            <Route path="/profil" element={<ProtectedRoute><Framed><Profil /></Framed></ProtectedRoute>} />

            <Route path="/jadwal" element={<ProtectedRoute><Framed nav={false}><Jadwal /></Framed></ProtectedRoute>} />
            <Route path="/absensi" element={<ProtectedRoute><Framed nav={false}><Absensi /></Framed></ProtectedRoute>} />
            <Route path="/hafalan" element={<ProtectedRoute><Framed nav={false}><Hafalan /></Framed></ProtectedRoute>} />
            <Route path="/doa" element={<ProtectedRoute><Framed nav={false}><Doa /></Framed></ProtectedRoute>} />
            <Route path="/materi" element={<ProtectedRoute><Framed nav={false}><Materi /></Framed></ProtectedRoute>} />
            <Route path="/kelola/konten" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><KontenHafalan /></Framed></ProtectedRoute>} />
            <Route path="/perkembangan" element={<ProtectedRoute><Framed nav={false}><Perkembangan /></Framed></ProtectedRoute>} />
            <Route path="/galeri" element={<ProtectedRoute><Framed nav={false}><Galeri /></Framed></ProtectedRoute>} />
            <Route path="/spp" element={<ProtectedRoute><Framed nav={false}><SPP /></Framed></ProtectedRoute>} />
            <Route path="/radio" element={<ProtectedRoute><Framed nav={false}><Radio /></Framed></ProtectedRoute>} />
            <Route path="/siswa/:id" element={<ProtectedRoute><Framed nav={false}><StudentProfile /></Framed></ProtectedRoute>} />

            <Route path="/kelola/absensi" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><InputAbsensi /></Framed></ProtectedRoute>} />
            <Route path="/kelola/hafalan" element={<ProtectedRoute roles={["guru", "admin"]}><Framed nav={false}><InputProgress /></Framed></ProtectedRoute>} />
            <Route path="/kelola/penilaian" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><InputPenilaian /></Framed></ProtectedRoute>} />
            <Route path="/kelola/siswa" element={<ProtectedRoute roles={["guru", "admin"]}><Framed nav={false}><ManageSiswa /></Framed></ProtectedRoute>} />
            <Route path="/kelola/guru/:teacherId" element={<ProtectedRoute roles={["guru", "admin"]}><Framed nav={false}><TeacherStudents /></Framed></ProtectedRoute>} />
            <Route path="/kelola/spp" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><ManageSPP /></Framed></ProtectedRoute>} />
            <Route path="/kelola/spp-laporan" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><SppReport /></Framed></ProtectedRoute>} />
            <Route path="/kelola/jadwal" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><ManageJadwal /></Framed></ProtectedRoute>} />
            <Route path="/kelola/export" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><ManageExport /></Framed></ProtectedRoute>} />
            <Route path="/admin/kehadiran/:kind" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><KehadiranDetail /></Framed></ProtectedRoute>} />
            <Route path="/kelola/import/:kind" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><ImportData /></Framed></ProtectedRoute>} />
            <Route path="/kelola/nomor-siswa" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><NomorSiswaImport /></Framed></ProtectedRoute>} />
            <Route path="/kelola/kajian-radio" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><ManageKajianRadio /></Framed></ProtectedRoute>} />
            <Route path="/kelola/users" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><ManageUsers /></Framed></ProtectedRoute>} />
            <Route path="/kelola/guru-detail/:teacherId" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><GuruDetail /></Framed></ProtectedRoute>} />
            <Route path="/kelola/ortu/:parentId" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><ParentDetail /></Framed></ProtectedRoute>} />
            <Route path="/kelola/monitor" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><MonitorUsers /></Framed></ProtectedRoute>} />
            <Route path="/laporan" element={<ProtectedRoute><Framed nav={false}><Laporan /></Framed></ProtectedRoute>} />
            <Route path="/kelola/laporan" element={<ProtectedRoute roles={["guru", "admin"]}><Framed nav={false}><InputLaporan /></Framed></ProtectedRoute>} />
            <Route path="/kegiatan" element={<ProtectedRoute roles={["guru", "admin"]}><Framed nav={false}><KegiatanGuru /></Framed></ProtectedRoute>} />
            <Route path="/riwayat" element={<ProtectedRoute roles={["guru", "admin"]}><Framed><Riwayat /></Framed></ProtectedRoute>} />
            <Route path="/kelola/laporan-guru" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><AdminGuruAttendance /></Framed></ProtectedRoute>} />
            <Route path="/kelola/laporan-guru/:teacherId" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><AdminGuruDetail /></Framed></ProtectedRoute>} />
            <Route path="/kelola/mukafaah" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><AdminMukafaah /></Framed></ProtectedRoute>} />
            <Route path="/kelola/kirim-pesan" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><AdminKirimPesan /></Framed></ProtectedRoute>} />
            <Route path="/admin/kehadiran/:kind/grup/:group" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><AdminAttendance /></Framed></ProtectedRoute>} />
            <Route path="/admin/kehadiran/:kind/kelas/:kelas" element={<ProtectedRoute roles={["admin"]}><Framed nav={false}><AdminAttendance /></Framed></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors offset={72} />
        </StudentProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
